<app-dialog
	modalTitle="Detalhes do arquivo"
	titleButton="Fechar"
	(dialogClose)="onClose()"
	(dialogSave)="onClose()"
>
	<div class="processing-detail">
		<section class="detail-section">
			<h3>Upload</h3>
			<div class="metadata-grid">
				<div class="metadata-item">
					<span>Nome do arquivo</span>
					<strong>{{ data.preProcessing.originalFileName }}</strong>
				</div>
				<div class="metadata-item">
					<span>Tamanho do arquivo</span>
					<strong>{{ formatBytes(data.preProcessing.size) }}</strong>
				</div>
				<div class="metadata-item">
					<span>Cliente</span>
					<strong>{{ data.preProcessing.organizationName }}</strong>
				</div>
				<div class="metadata-item">
					<span>Operadora</span>
					<strong>{{ data.preProcessing.operatorName }}</strong>
				</div>
				<div class="metadata-item">
					<span>Responsável</span>
					<strong>{{ data.preProcessing.uploadedBy }}</strong>
				</div>
				<div class="metadata-item">
					<span>Competência</span>
					<strong>{{ data.preProcessing.competence }}</strong>
				</div>
				<div class="metadata-item">
					<span>Enviado em</span>
					<strong>{{ formatDate(data.preProcessing.uploadedAt) }}</strong>
				</div>
			</div>
		</section>

		<section class="detail-section">
			<h3>Processamento</h3>
			<div class="metadata-grid">
				<div class="metadata-item">
					<span>Iniciado em</span>
					<strong>
						{{ formatOptionalDate(data.postProcessing?.startedAt) }}
					</strong>
				</div>
				<div class="metadata-item">
					<span>Status final</span>
					<strong>
						{{ getStatusLabel(data.postProcessing?.finalStatus) }}
					</strong>
				</div>
				<div class="metadata-item">
					<span>Total de linhas</span>
					<strong>
						{{ getPostProcessingValue(data.postProcessing?.totalRows) }}
					</strong>
				</div>
				<div class="metadata-item">
					<span>Linhas processadas</span>
					<strong>
						{{ getPostProcessingValue(data.postProcessing?.processedRows) }}
					</strong>
				</div>
				<div class="metadata-item">
					<span>Linhas com erro</span>
					<strong>
						{{ getPostProcessingValue(data.postProcessing?.failedRows) }}
					</strong>
				</div>
				<div class="metadata-item">
					<span>Finalizado em</span>
					<strong>
						{{ formatOptionalDate(data.postProcessing?.finishedAt) }}
					</strong>
				</div>
				<div
					class="metadata-item metadata-item-error"
					*ngIf="shouldShowPostProcessingError()"
				>
					<span>Tipo de erro</span>
					<strong class="operational-error-pill">
						{{ getPostProcessingErrorPresentation() }}
					</strong>
				</div>
			</div>
		</section>

		<section class="detail-section" *ngIf="data.errors?.length">
			<h3>Erros encontrados</h3>
			<div class="error-list">
				<div class="error-row" *ngFor="let error of data.errors">
					<span class="error-line-pill">
						{{ getErrorLineLabel(error) }}
					</span>
					<strong class="operational-error-pill">
						{{ getErrorItemPresentation(error) }}
					</strong>
					<small class="error-field" *ngIf="error.column">
						Campo: {{ error.column }}
					</small>
				</div>
			</div>
		</section>
	</div>
</app-dialog>
